import { createContext } from "react";

const ToastsContext = createContext();

export default ToastsContext;